module.exports = __webpack_public_path__ + "media/images/web/landings/teachers/s7-6f8e6570be582a708dc1de423e3b42aa.jpg";